import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { CustomButton, CustomCheckbox } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles } from '../../Common/constants';
import { getQuestionConfig } from '../../config/questionsConfig';

const SubIndustry = ({
  industryType,
  questionId,
  title = 'Sub Industry',
  titleHelperText = '(Select 1 or more)',
  subtitle = '',
  prompt = 'Which sub-industry do you work in?',
  options,
  value,
  defaultValue = [],
  onChange,
  onSubmit,
  submitLabel = 'Submit',
}) => {
  const questionConfig = getQuestionConfig(questionId);
  const resolvedOptions = useMemo(
    () => options || questionConfig?.options || [],
    [options, questionConfig],
  );

  const isControlled = Array.isArray(value);
  const [internalValue, setInternalValue] = useState(defaultValue);

  const selectedValues = isControlled ? value : internalValue;
  const selectedSet = useMemo(() => new Set(selectedValues), [selectedValues]);

  const updateSelection = (nextValues) => {
    if (!isControlled) {
      setInternalValue(nextValues);
    }
    onChange?.(nextValues);
  };

  const handleToggle = (optionValue) => (event) => {
    const nextValues = event.target.checked
      ? [...selectedValues, optionValue]
      : selectedValues.filter((item) => item !== optionValue);

    updateSelection(nextValues);
  };

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValues }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
        <CardHeader
          title={prompt}
          titleHelperText={titleHelperText}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', }}>
          {resolvedOptions.map((option) => (
            <CustomCheckbox
              key={option.value}
              checked={selectedSet.has(option.value)}
              onChange={handleToggle(option.value)}
              label={option.label}
            />
          ))}
        </Box>

        <CustomButton
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValues.length}
          size='small'
          sx={{
            width: '100%',
          }}
        />
      </Box>
    </Box>
  );
};

export default SubIndustry;
